import { TopBarNotificationType } from 'constants/notifications';
import type { KeyMap } from 'helpers/interface';
import { type ITopBarNotification } from 'interfaces/notification-bar';

import { isDesktopView } from './device';

interface ITopBarNotificationOptions {
  priority: number;
  visibleOnMobile: boolean;
}

export const getTopBarNotificationOptions = (type: TopBarNotificationType): ITopBarNotificationOptions => {
  // Higher priority should be displayed first
  const TopBarNotificationsOptions: KeyMap<ITopBarNotificationOptions> = {
    [TopBarNotificationType.TrialWarning]: {
      priority: 1,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.VisitorLimitExceeded]: {
      priority: 2,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.StatusAway]: {
      priority: 3,
      visibleOnMobile: true,
    },
    [TopBarNotificationType.Context25Campaign]: {
      priority: 4,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.LegacyMigration]: {
      priority: 4.5,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.EliminateLegacyStarterPlan]: {
      priority: 5,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.DownloadDesktopApp]: {
      priority: 6,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.TrialWarningImportant]: {
      priority: 7,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.SendPendingInvites]: {
      priority: 8,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.BrowserNotifications]: {
      priority: 9,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.InstallCode]: {
      priority: 10,
      visibleOnMobile: false,
    },
    [TopBarNotificationType.ConnectionRestored]: {
      priority: 11,
      visibleOnMobile: true,
    },
    [TopBarNotificationType.Reconnecting]: {
      priority: 12,
      visibleOnMobile: true,
    },
    [TopBarNotificationType.Offline]: {
      priority: 13,
      visibleOnMobile: true,
    },
  };

  return TopBarNotificationsOptions[type];
};

export const getVisibleNotifications = (notifications: ITopBarNotification[]): ITopBarNotification[] =>
  notifications
    .filter((notification) => {
      const options = getTopBarNotificationOptions(notification.name);

      return isDesktopView() || options?.visibleOnMobile === true;
    })
    .sort((a, b) => {
      const priorityA = getTopBarNotificationOptions(a.name)?.priority ?? Number.MAX_SAFE_INTEGER;
      const priorityB = getTopBarNotificationOptions(b.name)?.priority ?? Number.MAX_SAFE_INTEGER;

      return priorityA - priorityB;
    });
